function timeout() {
  return new Promise(resolve => setTimeout(resolve, 2000));
}

/**
 *
 * @param fn
 * @description funcion asincrona falsa. espera 2 segundos a resolver lo que aqui se pase.
 */
export async function sleep(fn: () => void): Promise<void> {
  await timeout();
  return fn();
}
